export default "<p>\r\n  Age Verification Coming Soon!\r\n</p>\r\n"